module.exports = __webpack_public_path__ + "img/Vector_4.557c2392.svg";